<ng-container *ngIf="isPopulated">
  <div edsGrid>
    <div
      edsSubGrid="layout-3"
      edsSpacing="md"
      edsFlexbox
      justifyContent="space-between"
    >
      <div>
        <eds-section-header
          [level]="4"
          size="h6"
          [title]="data.title"
          [caveatPlacement]="data.caveatPlacement"
          [secondaryCaveatPlacement]="data.secondaryCaveatPlacement"
          [tooltip]="data.tooltip"
          [analyticsName]="data.title"
          [asOfLabel]="data.asOfLabel"
          [asOfDate]="data.asOfDate"
          [calculationBasis]="data.calculationBasis"
          [calculationType]="data.calculationType"
          [updateFrequency]="data.updateFrequency"
        ></eds-section-header>
      </div>
      <div *ngIf="!data.isTopHoldingData">
        <a
          [edsButton]="'secondary'"
          [hasIcon]="true"
          href=""
          (click)="onDownloadButtonClicked($event)"
          [eventParams]="eventParams"
          [eventId]="eventId"
          data-analytics-no-event="true"
        >
          {{ "products.portfolio-download-all-holdings" | translate }}
          ({{ "products.xls-file-extension" | translate }})
          <eds-icon type="download" size="small"></eds-icon>
        </a>
      </div>
    </div>

    <div edsRow>
      <div edsCol>
        <eds-proximal [placement]="data.proximalTop"></eds-proximal>
        <eds-proximal
          *ngIf="data.secondaryProximalTop"
          [placement]="data.secondaryProximalTop"
        ></eds-proximal>
      </div>
    </div>

    <div edsRow>
      <div edsCol>
        <eds-search
          *ngIf="!data.isTopHoldingData"
          edsSpacing="md"
          edsCol
          [columnNumbers]="{
            s: 4,
            m: 8,
            l: 4
          }"
          [placeholder]="
            'products.portfolio-holdings-search-box-placeholder' | translate
          "
          (searchTerm)="filterHoldings($event)"
        ></eds-search>
      </div>
    </div>

    <div edsRow *ngIf="(isHandheld$ | async) === false" edsSpacing="md">
      <div edsCol>
        <ag-grid-angular
          #holdingsGrid
          style="width: 100%; height: 100%"
          class="ag-theme-frk ag-theme-frk--dark"
          [rowData]="sortedTableRows"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [frameworkComponents]="frameworkComponents"
          [paginationPageSize]="pageSize"
          [pagination]="true"
          [suppressPaginationPanel]="true"
          [suppressDragLeaveHidesColumns]="true"
          domLayout="autoHeight"
          rowHeight="90"
          [isExternalFilterPresent]="isExternalFilterPresent"
          [doesExternalFilterPass]="doesExternalFilterPass"
          overlayNoRowsTemplate="<p></p>"
          [context]="gridContext"
          [suppressRowHoverHighlight]="true"
          [suppressCellSelection]="false"
          [ensureDomOrder]="true"
          [suppressColumnVirtualisation]="true"
          (sortChanged)="onSortChanged()"
          (firstDataRendered)="onFirstDataRendered()"
          headerHeight="80"
        >
        </ag-grid-angular>
      </div>
    </div>

    <div *ngIf="isHandheld$ | async">
      <div class="cards-mobile">
        <eds-panel
          edsSpacing="sm"
          [hasBorders]="true"
          [hasBorderRadius]="false"
          [hasPadding]="true"
          *ngFor="let holding of currentPage"
        >
          <div *ngFor="let colDef of columnDefs">
            <eds-info-item
              *ngIf="!colDef.hide"
              [info]="getInfoItem(holding, colDef)"
              edsSpacing="sm"
            ></eds-info-item>
          </div>
        </eds-panel>
      </div>
    </div>

    <div edsRow *ngIf="sortedTableRows.length === 0">
      <div edsCol>
        <p class="bold large">
          {{ "products.portfolio-holdings-no-filter-data-message" | translate }}
        </p>
      </div>
    </div>

    <div edsRow edsSpacing="lg" *ngIf="showPagination && totalPages > 0">
      <div edsCol>
        <eds-pagination
          [pages]="totalPages"
          (pageChanged)="goToPage($event)"
        ></eds-pagination>
      </div>
    </div>
  </div>

  <div edsRow>
    <div edsCol>
      <eds-proximal [placement]="data.proximalBottom"></eds-proximal>
      <eds-proximal
        *ngIf="data.secondaryProximalBottom"
        [placement]="data.secondaryProximalBottom"
      ></eds-proximal>
    </div>
  </div>
</ng-container>
